import React, { useState, useEffect } from 'react';
import { X, FileText, Download, Loader } from 'lucide-react';
import { syncManager } from '../../services/sync';

const StatementModal = ({ onClose }) => {
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [users, setUsers] = useState([]);

    const [formData, setFormData] = useState({
        userEmail: '',
        month: new Date().toISOString().substring(0, 7), // YYYY-MM
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const rawUsers = await syncManager.fetchTabData('Users');
            if (rawUsers) {setUsers(rawUsers);}
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await syncManager.triggerWorkflow('hq-gen-statement', formData);
            alert('Statement generation triggered! It will be emailed/uploaded soon.');
            onClose();
        } catch (error) {
            alert('Error: ' + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {return <div className="p-10 text-center"><Loader className="animate-spin mx-auto" /></div>;}

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="bg-slate-50 border-b border-slate-100 p-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-100 p-2 rounded-xl text-blue-600">
                            <FileText size={20} />
                        </div>
                        <h2 className="text-xl font-black text-slate-800">Generate Statement</h2>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Select Client</label>
                            <select required value={formData.userEmail} onChange={e => setFormData({ ...formData, userEmail: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option value="">-- Choose User --</option>
                                {users.map(u => <option key={u.Client_Email} value={u.Client_Email}>{u.Client_Name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Statement Month</label>
                            <input type="month" value={formData.month} onChange={e => setFormData({ ...formData, month: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl" />
                        </div>
                        <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest flex items-center justify-center gap-2">
                            {submitting ? <Loader className="animate-spin" /> : <><Download size={20} /> Generate Statement</>}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StatementModal;
